export default {
  search: 'Искать страницу',
  create: 'Создать страницу',
  delete: 'Удалить'
};
